/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Loading_NoteInputs */

const en_fc_online_loading_note = /** @type {(inputs: Fc_Online_Loading_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first load downloads the editor (roughly 13 MB compressed). After that your browser caches it.`)
};

/**
* | output |
* | --- |
* | "The first load downloads the editor (roughly 13 MB compressed). After that your browser caches it." |
*
* @param {Fc_Online_Loading_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_loading_note = /** @type {((inputs?: Fc_Online_Loading_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Loading_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_loading_note(inputs)
});
export { fc_online_loading_note as "fc.online.loading_note" }